<template>
	<component :key="key" :is="formModule.component" :name="formModule.name" :reportName="formModule.reportName" />
</template>
<style scoped>


</style>
<script>
	import reportBase from '@_system/components/base/report.js'
	import loginMixins from '@_system/components/base/mixins/login/login.js'
	export default {
		mixins: [reportBase, loginMixins],
		props: {
			reportConfig: {
				type: Object,
				default: () => {
					return {
						name: '',
						reportName: '报表',
					}
				}
			},

		},
		data() {
			return {
				demoshow: true,
				key: Math.random(),
				moduleName: this.reportConfig.name,
				exportData: [],
				loading: false,
				show: false
			}
		},
		watch: {

		},
		computed: {
			nameMap() {
				return this.$store.state.reportMap
			}
		},
		created() {

			//this.formModule = this.reportConfig
		},
		mounted() {
			if (!this.$store.state.system.systemdata) {
				this.login_init()
			}else{
				this.login_handle()
			}
		},
		methods: {
			login_after() {
				this.load()
			},		
			load() {
				if (this.nameMap[this.reportConfig.name]) {
					window.document.title = this.reportConfig.reportName
					this.init()
				} else {
					this.$emit('back', 'cancle')
					this.$message.error('报表路径不存在')
				}
			},
			initList() {

			},
			init() {
				import(`@/${this.nameMap[this.reportConfig.name]}`).then((res) => {
					this.formModule = {
						component: res.default,
						name: this.reportConfig.name,
					}
				})
			},
			formBack(e) {
				this.$emit('back', e)
			},
			activeEdit() {
				this.$api.form.create({
					id: this.reportConfig.name,
					controlltype: 2,
					isflow: this.reportConfig.isflow,
					flowprogressid: this.reportConfig.flowprogressid,
					flowid: this.reportConfig.flowid
				}).then(() => {
					this.formModule.controlltype = 2
					this.key = Math.random()
				})
				//console.log(this.reportConfig)
			}
		}
	}
</script>